module.exports = __webpack_public_path__ + "media/images/Home Interior with Staircase, Windows and Front Door-da4ec4f7.jpg";